/**
 * EvolvingCurtain
 *
 * Public face of Mazo during the Skills Marketplace rollout. Shown to:
 *  - logged-out visitors (with a discreet sign-in link), and
 *  - signed-in accounts that are not on the early-access allowlist.
 *
 * Allowlisted accounts (and admins) never see this — they get the full app.
 */

const font = "'Outfit', sans-serif";

interface EvolvingCurtainProps {
  /** 'signed-out' shows a discreet sign-in; 'no-access' shows sign-out. */
  mode: 'signed-out' | 'no-access';
  email?: string;
  onSignIn?: () => void;
  onSignOut?: () => void;
}

export function EvolvingCurtain({ mode, email, onSignIn, onSignOut }: EvolvingCurtainProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-6">
      <div className="text-center max-w-md">
        <img src="/logo.svg" alt="Mazo" className="mx-auto mb-6 h-14 w-14" />
        <h1 className="text-3xl font-medium text-gray-900" style={{ fontFamily: font }}>
          Mazo is evolving
        </h1>
        <p className="mt-3 text-gray-600 leading-relaxed" style={{ fontFamily: font }}>
          We&rsquo;re building something new — a curated store of high-value AI skills
          you can install into Claude&nbsp;Code, ChatGPT, Cursor and beyond.
        </p>
        <p className="mt-2 text-gray-500 text-sm" style={{ fontFamily: font }}>
          {mode === 'no-access'
            ? 'Your account isn’t part of the early-access group yet. We’ll be in touch soon.'
            : 'Early access is open to a small group while we get things ready.'}
        </p>

        {mode === 'no-access' ? (
          <div className="mt-8">
            {email && (
              <p className="text-xs text-gray-400 mb-3" style={{ fontFamily: font }}>
                Signed in as {email}
              </p>
            )}
            <button
              onClick={onSignOut}
              className="text-sm text-gray-500 underline underline-offset-4 hover:text-gray-700"
              style={{ fontFamily: font }}
            >
              Sign out
            </button>
          </div>
        ) : (
          <div className="mt-8">
            <button
              onClick={onSignIn}
              className="text-sm text-gray-400 hover:text-mazo-600 transition-colors"
              style={{ fontFamily: font }}
            >
              Have early access? Sign in
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
